import React from "react";
import ExportSheet from "./ExportSheet";
import SendNotification from "./SendNotification";

const HeaderButtons = ({ userRole, selectedIds }) => {
  return (
    <div className="flex items-center justify-between gap-2">
      <SendNotification userRole={userRole} selectedIds={selectedIds} />
      <ExportSheet />
    </div>
  );
};

export default HeaderButtons;
